import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import axios from "axios";
import { useEffect, useState } from 'react';
import { showToaster } from '../toster';

function AddFamilyMember({ Show, close }) {
    const [errors, setErrors] = useState({});
    const [getRelationship, setGetRelationship] = useState([]);
    const [ageCalcu, setAgeCalcu] = useState("");
    const [formData, setFormData] = useState({
        RelationID: "",
        MemberName: "",
        DOB: "",
    });

    console.log(formData, "formData");

    const currentYear = new Date().getFullYear();

    // Function to calculate DOB from age
    const calculateDOB = (age) => {
        if (!age || isNaN(age)) return "";
        const birthYear = currentYear - parseInt(age, 10);
        return `01-01-${birthYear}`;
    };

    useEffect(() => {
        if (formData.DOB) {
            const dobFormatted = calculateDOB(formData.DOB);
            setAgeCalcu(dobFormatted);
        }
    }, [formData.DOB]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        console.log({ name, value });

        setFormData((prev) => ({
            ...prev,
            [name]: name === "RelationID" ? (value ? parseInt(value, 10) : "") : value,
        }));
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.RelationID) newErrors.RelationID = "Please select your relative.";
        if (!formData.MemberName.trim()) newErrors.MemberName = "Please enter your relative's name.";
        if (!formData.DOB || !/^\d{2}-\d{2}-\d{4}$/.test(ageCalcu)) {
            newErrors.DOB = "Please enter a valid age.";
        }
        return newErrors;
    };

    const token = localStorage.getItem("smc-csp-token");

    const AddMember = async () => {
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        const formattedData = {
            ...formData,
            DOB: ageCalcu, // Send formatted date, not age
        };

        try {
            const { data } = await axios.post(
                "https://www.smcinsurance.com/CustomerPanelApi/api/Customers/GetCustomerFamilyTree_Add",
                formattedData,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (data.StatusCode === 200) {
                showToaster({ message: data.Data, type: "success" });
                close();
            } else {
                showToaster({ message: data.ErrorMessage, type: "error" });
            }
        } catch (error) {
            console.error("Error submitting request:", error);
            alert("Failed to submit request. Please try again.");
        }
    };

    const relationShipData = [
        { name: 'Self', value: 1, key: 69 },
        { name: 'Father', value: 2, key: 32 },
        { name: 'Mother', value: 3, key: 36 },
        { name: 'Son', value: 4, key: 43 },
        { name: 'Daughter', value: 5, key: 44 },
        { name: 'Spouse', value: 6, key: 263 },
        { name: 'Brother', value: 7, key: 46 },
        { name: 'Sister', value: 8, key: 45 },
    ];

    useEffect(() => {
        setGetRelationship(relationShipData);
    }, []);

    return (
        <Modal show={Show} onHide={close}>
            <Modal.Header closeButton>
                <Modal.Title>Add New Member</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FloatingLabel className="mb-3" controlId="floatingSelect" label="Relationship">
                    <Form.Select
                        name="RelationID"
                        value={formData.RelationID}
                        onChange={handleChange}
                    >
                        <option value="">Who is the policy holder</option>
                        {getRelationship.map((relation, index) => (
                            <option key={index} value={relation.key}>
                                {relation.name}
                            </option>
                        ))}
                    </Form.Select>
                    {errors.RelationID && <span style={{ color: "red" }}>{errors.RelationID}</span>}
                </FloatingLabel>

                <FloatingLabel controlId="floatingInput" label="Full Name" className="mb-3">
                    <Form.Control
                        type="text"
                        name="MemberName"
                        value={formData.MemberName}
                        onChange={handleChange}
                        placeholder="Full Name"
                    />
                    {errors.MemberName && <span style={{ color: "red" }}>{errors.MemberName}</span>}
                </FloatingLabel>

                <FloatingLabel controlId="floatingInput" label="Age" className="mb-3">
                    <Form.Control
                        type="number"
                        name="DOB"
                        value={formData.DOB}
                        onChange={handleChange}
                        placeholder="Enter Age"
                    />
                    {errors.DOB && <span style={{ color: "red" }}>{errors.DOB}</span>}
                </FloatingLabel>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={close}>
                    Close
                </Button>
                <Button variant="primary" onClick={AddMember}>
                    Save Changes
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default AddFamilyMember;
